
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  Form,
  FormItem,
  Input,
  Button,
  Radio,
  DatePicker,
  Upload,
  Select,
  Option,
  InputNumber,
  Row,
  Col,
  Cascader,
} from 'element-ui';
import moment from 'moment';
import QuesApi from '@/api/question';
import api from '@/api/course';
import Util from '@/libs/util';
import myVditor from '@/components/Markdown/vditor.vue';

@Component({
  components: {
    Form,
    FormItem,
    Input,
    Button,
    Radio,
    DatePicker,
    Upload,
    Select,
    Option,
    InputNumber,
    Row,
    Col,
    Cascader,
    myVditor,
  },
})

export default class firstStep extends Vue {
  @Prop({
    required: true,
    default: false,
  }) oldForm!: any;

  @Prop({
    required: true,
    default: false,
  }) title!: any;

  private statusList: { value: number; label: string; }[] = [{ value: 1, label: '启用' }, { value: 0, label: '停用' }];

  private typeList: { value: number; label: string; }[] = [{ value: 1, label: '线下' }, { value: 2, label: '线上' }];

  private tidOpts: any = [];

  private fileListIcon: any = [];

  private fileListImg: any = [];

  private standardConfigs: any = [];

  public form: any = {
    courseTitle: '',
    courseVersion: '',
    courseDesc: '',
    courseClassification: '',
    courseImage: '',
    courseIco: '',
    courseType: '',
    courseStatus: '',
    classHours: '',
    standardNumber: 0,
    stepTotal: '',
    chapterTitleView: 'SEQUENCE',
    editorType: '',
  }

  public loading: boolean = false;

  public $refs!: {
    form: Form,
    myVditor: myVditor,
  };

  private rules: any = {
    courseTitle: [
      { required: true, message: '标题不能为空' },
    ],
    courseClassification: [
      { required: true, message: '您必须选择课程分类' },
    ],
    courseDesc: [
      { required: true, message: '您必须输入简介' },
    ],
    courseType: [
      { required: true, message: '您必须选择课程类别' },
    ],
    stepTotal: [
      { required: true, message: '您必须输入课程章节数' },
    ],
    courseStatus: [
      { required: true, message: '您必须选择课程状态' },
    ],
    classHours: [
      { required: true, message: '您必须输入课时' },
    ],
    standardNumber: [
      { type: 'number', required: true, meessagee: '请选择课时基数' },
    ],
    chapterTitleView: [
      { required: true, message: '您必须输入章节标题显示方式' },
    ],
    editorType: [
      { required: true, message: '您必须选择编辑器类型' },
    ],
  };

  private editorTypeList: any = [
    {
      label: 'Scratch 3.0',
      value: 'U2FsdGVkX',
    },
    {
      label: 'Python',
      value: 'DnVaryx0CLJv',
    },
    {
      label: 'C++',
      value: '65S6k67PR',
    },
    {
      label: 'Microbit',
      value: 'A9UdYEdHP',
    },
    {
      label: 'Javascript',
      value: '184w1oQFh',
    },
    {
      label: 'HTML5',
      value: '18KIo5Rs8v1',
    },
    {
      label: 'Scratch 2.0',
      value: 'zKTYcHqz8P',
    },
  ]

  getCourseType() {
    QuesApi.getCourseType().then((res: any) => {
      this.tidOpts = Util.CompTreeNode(res, 'children');
    });
  }

  getstandardConfig() {
    api.getCourseStandardNumber().then((res: any) => {
      this.standardConfigs = res;
    });
  }

  mounted() {
    this.getstandardConfig();
    this.getCourseType();
    if (this.title.includes('编辑')) {
      const {
        courseTitle,
        courseVersion,
        courseDesc,
        courseClassification,
        courseType,
        courseStatus,
        classHours,
        standardNumber,
        stepTotal,
        chapterTitleView,
        editorType,
      } = this.oldForm;
      this.form = {
        courseTitle,
        courseVersion,
        courseDesc,
        courseClassification,
        courseType,
        courseStatus,
        classHours,
        standardNumber,
        stepTotal,
        chapterTitleView,
        editorType,
      };
      this.fileListIcon = [{ url: this.oldForm.courseIco }];
      this.fileListImg = [{ url: this.oldForm.courseImage }];
    }
  }


  /**
   * @author lianguongmou
   * @desc 图片上传前事件
    */
  handleBeforeUpload(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e:any) => {
      this.fileListImg = [{ url: e.target.result }];
    };
    this.form.courseImage = file;
    return false;
  }

  /**
   * @author liangyongmou
   * @desc 主图片删除事件
   * @params { any } file 文件
   */
  handleBeforeRemove(file: any) {
    if (file.status === 'success') this.form.courseImage = '';
  }

  /**
   * @author liangyongmou
   * @desc 缩略图改变事件
   * @params { any } file 文件
   */
  handleIconBeforeRemove(file: any) {
    if (file.status === 'success') this.form.courseIco = '';
  }

  /**
   * @author lianguongmou
   * @desc 图片上传前事件
   */
  handleIconBeforeUpload(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e:any) => {
      this.fileListIcon = [{ url: e.target.result }];
    };
    this.form.courseIco = file;
    return false;
  }

  /**
   * @author liangyongmou
   * @desc 分类改变事件
   * @param { any } v 分类数组
   */
  handleTidchange(v: any) {
    // eslint-disable-next-line prefer-destructuring
    this.form.courseClassification = v[1];
  }

  /**
   * @author liangyongmou
   * @desc 简介编辑器输入事件
   * @param { string } value 编辑器内容
   */
  handleCourseDescInput(value: string) {
    this.form.courseDesc = value || '';
    // 清除该字段的验证错误，当用户输入内容后，错误提示会消失
    this.$nextTick(() => {
      if (this.$refs.form) {
        this.$refs.form.clearValidate('courseDesc');
      }
    });
  }

  /**
   * @author liangyongmou
   * @desc 提交事件
   * @param 空
   */
  handleSubmit() {
    let result:any = {};
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        // 获取 markdown 编辑器的值
        if (this.$refs.myVditor) {
          const markdownValue = this.$refs.myVditor.getMarkdownValue();
          this.form.courseDesc = markdownValue || '';
        }
        result = this.form;
      }
    });
    return result;
  }
}
